export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
    "login.form.title": "登录",
    "login.form.hint.user": "登录名",
    "login.form.hint.password": "密码",
    "login.form.checkbox.remember-me": "记住我",
    "login.form.button.sign-in": "登录",
    "login.form.message.invalid-user-credentials": "登录名或密码不正确",
    "login.form.message.user-required": "输入登录名",
    "login.form.message.password-required": "输入密码",
    "login.form.button.forgot-password": "忘记密码？",
    "error.root-admin-login.title": "Error 403 – 已禁止",
    "error.root-admin-login.message": "您已作为只读管理员登录。访问 Web Recovery 中控台，请以客户租户或管理员身份登录"
};
